import React, { useState, useEffect } from "react";
import { css } from "emotion";
import DOMPurify from "dompurify";
import { Table, Grid, Icon } from "semantic-ui-react";
import { getRequest } from "../../helpers/ApiHelpers";
import { withRouter } from "react-router-dom";
import CustomTable from "../CustomTable";

function States({ history }) {
  const [state, setState] = useState({
    initialLoading: true,
    states: []
  });

  async function getStates() {
    const result = await getRequest("/adminState/getStates");
    if (result.success) {
      setState(state => ({
        ...state,
        states: result.data,
        initialLoading: false
      }));
    }
  }

  useEffect(() => {
    getStates();
  }, []);

  function hasNote(note) {
    return note && note !== "<p><br></p>";
  }

  return (
    <React.Fragment>
      <div
        className={css({
          marginBottom: 19.75
        })}
      >
        <Grid>
          <Grid.Row columns={1} verticalAlign="middle">
            <Grid.Column floated="left">
              <div
                className={css({
                  fontFamily: "Fakt-Bold",
                  fontSize: 20,
                  lineHeight: 1.2,
                  color: "#47517b",
                  display: "inline-block",
                  marginRight: 64
                })}
              >
                States
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <CustomTable
          customStyles={{
            "& tr td:first-of-type": {
              paddingLeft: "40.5px !important"
            },
            "& th": {
              position: "sticky",
              top: 0,
              zIndex: 1
            }
          }}
        >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={4}>State</Table.HeaderCell>
              <Table.HeaderCell>Note</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {state.states.length < 1 && (
              <Table.Row>
                <Table.Cell>No states available</Table.Cell>
              </Table.Row>
            )}
            {state.states.map(s => (
              <Table.Row key={s.id}>
                <Table.Cell
                  style={{
                    textAlign: "left"
                  }}
                >
                  <span className={css({ fontFamily: "Fakt-Bold" })}>
                    {s.name}
                  </span>
                </Table.Cell>
                <Table.Cell
                  style={{
                    textAlign: "left"
                  }}
                >
                  <span
                    className={css({
                      "&:hover i": { color: "#00b8d4" },
                      cursor: "pointer",
                      verticalAlign: "top",
                      display: "inline-block"
                    })}
                    onClick={() => history.push(`/admin/edit-state/${s.id}`)}
                  >
                    <Icon
                      style={{ paddingRight: 32.5 }}
                      className="fal fa-pen"
                    />
                  </span>
                  <div
                    className={css({
                      display: "inline-block",
                      verticalAlign: "top",
                      width: "calc(100% - 70px)"
                    })}
                  >
                    {hasNote(s.note) ? (
                      <div
                        className={css({
                          lineHeight: 1.35,
                          "& p": {
                            margin: "0 0 6px"
                          },
                          "& p:last-child": {
                            marginBottom: 0
                          },
                          "& ul, & ol": {
                            marginTop: 0,
                            marginBottom: 6,
                            paddingLeft: 20
                          }
                        })}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(s.note)
                        }}
                      />
                    ) : (
                      <span className={css({ opacity: 0.6 })}>
                        No note added
                      </span>
                    )}
                  </div>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </CustomTable>
      </div>
    </React.Fragment>
  );
}

export default withRouter(States);
